import { IGetGameUrl } from '../../types/slot';

import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IWInfinityServerGame, IWInfinityGetGameUrl } from '../../types/interfaces/LiveCasino/WInfinityDTO';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<{ items: IWInfinityServerGame[] }>): ISlotViewItem[] =>
    data.items
      .filter(game => game.isLiveGame)
      .flatMap(game => {
        if (game.isLobby) {
          // все игры из лобби
          return [
            ...game.lobby_data.items.map(item => ({
              imageUrl: `/images/winfinity/${item.providerTableId}.png`,
              tab: [item.tableDetails.lobbyType.toLowerCase()],
              gameId: item.tableId,
              tableId: game.id,
              type: CasinoType.liveCasino,
              provider: game.providerName.toLowerCase(),
              description: item.providerTableName,
              gameName: item.providerTableName,
              routeProvider: 'winfinityLive',
              id: item.tableId,
            })),
            // само лобби
            // {
            //   imageUrl: `/images/winfinity/${game.id}.png`,
            //   tab: [],
            //   gameId: game.id,
            //   tableId: '',
            //   provider: game.providerName.toLowerCase(),
            //   description: game.name,
            //   gameName: game.name,
            //   routeProvider: 'winfinityLive',
            //   id: game.id,
            // }
          ];
        }
        // обычная игра
        return {
          imageUrl: `/images/winfinity/${game.id}.png`,
          tab: [],
          gameId: game.id,
          tableId: '',
          type: CasinoType.liveCasino,
          provider: game.providerName.toLowerCase(),
          description: game.name,
          gameName: game.name,
          routeProvider: 'winfinityLive',
          id: game.id,
        };
      });

  convertGameUrl = ({ data }: IGetGameUrl<IWInfinityGetGameUrl, unknown>) => data.url;
}

export default Converter;
